const eventId = process.env.REACT_APP_EVENT_ID;
const BASE_URL = `/api/contest`;

const API = {
  CONTEST: `${BASE_URL}/${eventId}1`,
  ACTIVITY: (table) => `${BASE_URL}/${eventId}${table}/recently-votes`,
  CONTESTANT: (table) => `${BASE_URL}/${eventId}${table}/contestant`,
  RANK: (table) => `${BASE_URL}/${eventId}${table}/rank`,
  CONTESTANT_DETAIL: (missId, table) =>
    `${BASE_URL}/${eventId}${table}/contestant/${missId}`,
  VOTE_LIST: (missId, pageNumber, pageSize, table) =>
    `${API.CONTESTANT(
      table
    )}/${missId}/votes?page=${pageNumber}&pageSize=${pageSize}`,
  PAY_URL: (gateway, missId, table) =>
    `${BASE_URL}/${eventId}${table}/payment/${gateway}/${missId}`,
};

export default API;
